/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const ruRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Запрос на добавление школы',
    description: 'Пожалуйста, заполните форму ниже. Добавление всех школ, по которым будут представлены данные, не гарантируется, однако SheerID изучает и рассматривает все получаемые запросы. ',
    noCountry: 'Не видите страну вашей школы? На вас не распространяется данное предложение',
    searchByOrgName: 'Не видите вашу школу? Поиск по имени',
    completeRequest: 'Не видите свою школу в списке отвечающих или не отвечающих требованиям школ? Заполните ваш запрос',
    submit: 'Отправить запрос',
    eligibleOrgs: 'Школы, отвечающие требованиям. Нажмите на иконку, чтобы скопировать имя, а затем вернитесь в форму проверки',
    ineligibleOrgs: 'Школы, не отвечающие требованиям. К сожалению, на учеников данных школ это предложение не распространяется',
    none: 'Нет',
    country: 'Где вы посещаете школу?',
    changeLanguage: 'Изменить язык',
    copied: 'Скопировано',
    firstName: 'Имя',
    lastName: 'Фамилия',
    emailAddress: 'Адрес электронной почты',
    poweredBy: 'Сервис верификации работает при поддержке SheerID',
    fields: {
        countryPlaceholder: 'Выберите страну',
        domainLabel: 'Сайт школы',
        domainPlaceholder: 'www.moyashkola.ru',
        orgNameLabel: 'Название школы',
        orgNamePlaceholder: 'Моя школа',
    },
    step: {
        success: {
            title: 'Благодарим вас',
            description: 'Ваш запрос на добавление учебного заведения получен. Обратите внимание, обработка запроса может занять до 7 дней, при этом нет гарантии, что учебное заведение будет добавлено в список учреждений, соответствующих требованиям на получение доступа к программам Autodesk в образовательных целях.<br><br>Тем временем вы можете ознакомиться с другими вариантами подписки.',
        },
        error: {
            title: 'Произошла непредвиденная ошибка',
            description: 'К сожалению, мы не можем обработать ваш запрос. Пожалуйста, повторите попытку позже.',
            seeingProblem: 'Если проблема так и не разрешится,',
            contactUs: 'свяжитесь с нами',
        },
    },
    errorId: {
        invalidCountry: 'Поле обязательно для заполнения',
        invalidEmail: 'Недопустимый адрес электронной почты',
        invalidFirstName: 'Недопустимое имя',
        invalidLastName: 'Недопустимая фамилия',
        requiredField: 'Поле обязательно для заполнения',
        invalidField: 'Недопустимый формат',
        invalidUrl: 'Недопустимый URL-адрес',
        tooManyResults: 'Ваш поиск дал слишком много результатов. Пожалуйста, уточните критерии поиска и повторите попытку',
    },
    faq: 'FAQ по запросу на добавление школы от SheerID ',
    countries: {
        AD: 'Андорра',
        AE: 'Объединенные Арабские Эмираты',
        AF: 'Афганистан',
        AG: 'Антигуа и Барбуда',
        AI: 'Ангилья',
        AL: 'Албания',
        AM: 'Армения',
        AN: 'Нидерландские Антильские Острова',
        AO: 'Ангола',
        AR: 'Аргентина',
        AS: 'Американское Самоа',
        AT: 'Австрия',
        AU: 'Австралия',
        AW: 'Аруба',
        AZ: 'Азербайджан',
        BA: 'Босния и Герцеговина',
        BB: 'Барбадос',
        BD: 'Бангладеш',
        BE: 'Бельгия',
        BF: 'Буркина-Фасо',
        BG: 'Болгария',
        BH: 'Бахрейн',
        BI: 'Бурунди',
        BJ: 'Бенин',
        BM: 'Бермудские острова',
        BN: 'Бруней-Даруссалам',
        BO: 'Боливия',
        BR: 'Бразилия',
        BS: 'Багамские о-ва',
        BT: 'Бутан',
        BV: 'Остров Буве',
        BW: 'Ботсвана',
        BY: 'Беларусь',
        BZ: 'Белиз',
        CA: 'Канада',
        CD: 'Демократическая Республика Конго',
        CF: 'Центрально-Африканская Республика',
        CG: 'Конго',
        CH: 'Швейцария',
        CI: 'Берег Слоновой Кости (Кот-д\'Ивуар)',
        CK: 'Острова Кука',
        CL: 'Чили',
        CM: 'Камерун',
        CN: 'Китай',
        CO: 'Колумбия',
        CR: 'Коста-Рика',
        CU: 'Куба',
        CV: 'Кабо-Верде',
        CY: 'Кипр',
        CZ: 'Чехия',
        DE: 'Германия',
        DJ: 'Джибути',
        DK: 'Дания',
        DM: 'Доминика',
        DO: 'Доминиканская Республика',
        DZ: 'Алжир',
        EC: 'Эквадор',
        EE: 'Эстония',
        EG: 'Египет',
        EH: 'Западная Сахара',
        ER: 'Эритрея',
        ES: 'Испания',
        ET: 'Эфиопия',
        FI: 'Финляндия',
        FJ: 'Фиджи',
        FK: 'Фолклендские острова',
        FM: 'Микронезия',
        FO: 'Фарерские острова',
        FR: 'Франция',
        GA: 'Габон',
        GB: 'Соединенное Королевство',
        GD: 'Гренада',
        GE: 'Грузия',
        GF: 'Французская Гвиана',
        GH: 'Гана',
        GI: 'Гибралтар',
        GL: 'Гренландия',
        GM: 'Гамбия',
        GN: 'Гвинея',
        GP: 'Гваделупа (Франция)',
        GQ: 'Экваториальная Гвинея',
        GR: 'Греция',
        GS: 'Южная Георгия и Южные Сандвичевы острова',
        GT: 'Гватемала',
        GU: 'Гуам (США)',
        GW: 'Гвинея-Бисау',
        GY: 'Гайана',
        HK: 'Гонконг',
        HM: 'Острова Херд и Макдональд',
        HN: 'Гондурас',
        HR: 'Хорватия',
        HT: 'Гаити',
        HU: 'Венгрия',
        ID: 'Индонезия',
        IE: 'Ирландия',
        IL: 'Израиль',
        IN: 'Индия',
        IO: 'Британская территория в Индийском океане',
        IQ: 'Ирак',
        IR: 'Иран',
        IS: 'Исландия',
        IT: 'Италия',
        JM: 'Ямайка',
        JO: 'Иордания',
        JP: 'Япония',
        KE: 'Кения',
        KG: 'Киргизия',
        KH: 'Камбоджа',
        KI: 'Кирибати',
        KM: 'Коморские острова',
        KN: 'Сент-Китс и Невис Ангилья',
        KP: 'Северная Корея',
        KR: 'Южная Корея',
        KW: 'Кувейт',
        KY: 'Каймановы острова',
        KZ: 'Казахстан',
        LA: 'Лаос',
        LB: 'Ливан',
        LC: 'Сент-Люсия',
        LI: 'Лихтенштейн',
        LK: 'Шри-Ланка',
        LR: 'Либерия',
        LS: 'Лесото',
        LT: 'Литва',
        LU: 'Люксембург',
        LV: 'Латвия',
        LY: 'Ливия',
        MA: 'Марокко',
        MC: 'Монако',
        MD: 'Молдавия',
        ME: 'Черногория',
        MG: 'Мадагаскар',
        MH: 'Маршалловы острова',
        MK: 'Македония',
        ML: 'Мали',
        MM: 'Мьянма',
        MN: 'Монголия',
        MO: 'Макао',
        MP: 'Северные Марианские острова',
        MQ: 'Мартиника (Франция)',
        MR: 'Мавритания',
        MS: 'Монсеррат',
        MT: 'Мальта',
        MU: 'Маврикий',
        MV: 'Мальдивы',
        MW: 'Малави',
        MX: 'Мексика',
        MY: 'Малайзия',
        MZ: 'Мозамбик',
        NA: 'Намибия',
        NC: 'Новая Каледония (Франция)',
        NE: 'Нигер',
        NF: 'Остров Норфолк',
        NG: 'Нигерия',
        NI: 'Никарагуа',
        NL: 'Нидерланды',
        NO: 'Норвегия',
        NP: 'Непал',
        NR: 'Науру',
        NU: 'Ниуэ',
        NZ: 'Новая Зеландия',
        OM: 'Оман',
        PA: 'Панама',
        PE: 'Перу',
        PF: 'Полинезия (Франция)',
        PG: 'Папуа - Новая Гвинея',
        PH: 'Филиппины',
        PK: 'Пакистан',
        PL: 'Польша',
        PM: 'Сен-Пьер и Микелон',
        PN: 'Остров Питкэрн',
        PR: 'Пуэрто-Рико',
        PS: 'Палестина',
        PT: 'Португалия',
        PW: 'Палау',
        PY: 'Парагвай',
        QA: 'Катар',
        RE: 'Реюньон (Франция)',
        RO: 'Румыния',
        RS: 'Сербия',
        RU: 'Российская Федерация',
        RW: 'Руанда',
        SA: 'Саудовская Аравия',
        SB: 'Соломоновы острова',
        SC: 'Сейшельские острова',
        SD: 'Судан',
        SE: 'Швеция',
        SG: 'Сингапур',
        SH: 'Остров Святой Елены',
        SI: 'Словения',
        SK: 'Словакия',
        SL: 'Сьерра-Леоне',
        SM: 'Сан-Марино',
        SN: 'Сенегал',
        SO: 'Сомали',
        SR: 'Суринам',
        SS: 'южный Судан',
        ST: 'Сан-Томе и Принсипи',
        SV: 'Сальвадор',
        SY: 'Сирия',
        SZ: 'Свазиленд',
        TC: 'Тёркс и Кайкос',
        TD: 'Чад',
        TF: 'Французские Южные территории',
        TG: 'Того',
        TH: 'Таиланд',
        TJ: 'Таджикистан',
        TK: 'Токелау',
        TL: 'Восточный Тимор',
        TM: 'Туркменистан',
        TN: 'Тунис',
        TO: 'Тонга',
        TR: 'Турция',
        TT: 'Тринидад и Тобаго',
        TV: 'Тувалу',
        TW: 'Тайвань',
        TZ: 'Танзания',
        UA: 'Украина',
        UG: 'Уганда',
        UM: 'Внешние малые острова США',
        US: 'Соединенные Штаты',
        UY: 'Уругвай',
        UZ: 'Узбекистан',
        VA: 'Ватикан',
        VC: 'Сент-Винсент и Гренадины',
        VE: 'Венесуэла',
        VG: 'Виргинские острова (Великобритания)',
        VI: 'Виргинские острова (США)',
        VN: 'Вьетнам',
        VU: 'Вануату',
        WF: 'Острова Уоллис и Футуна',
        WS: 'Самоа',
        XK: 'Косово',
        YE: 'Йемен',
        YT: 'Майотта',
        ZA: 'Южная Африка',
        ZM: 'Замбия',
        ZW: 'Зимбабве',
    },
    locales: {
        ar: 'Арабский',
        bg: 'Болгарский',
        cs: 'Чешский',
        da: 'Датский',
        de: 'Немецкий',
        el: 'Греческий',
        'en-GB': 'Английский (Соединенное Королевство)',
        'en-US': 'Английский',
        'es-ES': 'Испанский (Испания)',
        es: 'Испанский',
        fi: 'Финский',
        'fr-CA': 'Французский (Канада)',
        fr: 'Французкий',
        hr: 'Хорватский',
        hu: 'Венгерский',
        id: 'Индонезийский',
        is: 'Исландский',
        it: 'Итальянский',
        iw: 'Иврит',
        ja: 'Японский',
        ko: 'Корейский',
        lt: 'Литовский',
        ms: 'Малайский',
        nl: 'Нидерландский',
        no: 'Норвежский',
        pl: 'Польский',
        'pt-BR': 'Португальский (Бразилия)',
        pt: 'Португальский',
        ro: 'Румынский',
        ru: 'Русский',
        sk: 'Словацкий',
        sl: 'Словенский',
        sr: 'Сербский',
        sv: 'Шведский',
        tr: 'Турецкий',
        'zh-HK': 'Китайский (Гонконг)',
        zh: 'Китайский (Традиционный)',
    },
};
